import React, { useMemo } from 'react'
import { SaveIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { AdvanceStepButton } from '../AdvanceStepButton'
import { ServiceResponse } from '@mutual-libs/shared-types'
import { FetchRequestDocumentsOutput } from '~/utils/documents'
import { Button, Box, CircularProgress } from '@material-ui/core'
import { DocumentsGroup } from '@mutual-services/account-documents-types'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    marginTop: mutualTheme.spacing(2),
    [mutualTheme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'space-between'
    }
  },
  saveButton: {
    height: 56,
    fontWeight: 700,
    textTransform: 'none',
    marginRight: mutualTheme.spacing(1)
  }
})

export type DocumentationTabProps = {
  formId?: string,
  isLoading: boolean,
  onSave?: () => void,
  docData: FetchRequestDocumentsOutput[],
  documentsList: ServiceResponse<DocumentsGroup[]>
}

export const DocumentationActionButtons: React.FC<DocumentationTabProps> = (props) => {
  const { isLoading, onSave, docData, documentsList } = props
  const classes = useStyles()

  const saveButtonIcon = useMemo(() => {
    return isLoading ? <CircularProgress color='inherit' size={17} /> : <SaveIcon width={24} height={24} />
  }, [isLoading])

  return (
    <Box className={classes.container}>
      <Button
        type='submit'
        size='large'
        color='primary'
        onClick={onSave}
        variant='contained'
        disabled={isLoading}
        endIcon={saveButtonIcon}
        className={classes.saveButton}
      >
        Salvar
      </Button>
      <AdvanceStepButton
        docData={docData}
        documentsList={documentsList}
      />
    </Box>
  )
}
